// extracted by mini-css-extract-plugin
module.exports = {"image":"User_image__3qu9g","user":"User_user__3Gf0m","species":"User_species__3kIO_","buttons":"User_buttons__2o7Hf","name":"User_name__2ZmwU","sciName":"User_sciName__2hdxQ"};